import {useApiRemove} from "../../../../../lib/HttpService";
import {PATH} from "./const";
import {StubbornScreen} from "../../../../../application/business/StubbornAsset";

export const useEditionScreenRemove = () => useApiRemove<StubbornScreen>(PATH);
